import React from 'react';
import { Link } from "react-router-dom";

import "../styles/Title.css";

let isIE = /*@cc_on!@*/false || !!document.documentMode;

var Title = () => (
  <div className="title">
    <img className="header" src={require("../assets/header-footer-colours.jpg")} alt="Header" /> 
    <img className="ufLogo" src={require("../assets/Unforgotten Forces logo-hi-res.jpg")} alt="Unforgotten Forces Logo" />
    <div className="bbbLogo" >
      <img src={require("../assets/power-quiz-logo.png")} alt="Power Quiz Logo" />
    </div>
    <img className="asLogo" src={require("../assets/ageScotlandLogo.png")} alt="ageScotland Logo" />
    <Link className="button" to="/about">Next</Link>
    <img className="footer" src={require("../assets/header-footer-colours.jpg")} alt="Footer" /> 
  </div>
);

if(isIE){
  Title = () => (
  <div className="ie-title">
    <div className="header-footer">
      <img className="header" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
    </div>
    <div className="pageContent">
      <div className="logos"> 
        <div className="col-4"></div>
        <div className="col-4">
          <img className="bbbLogo" src={require("../assets/power-quiz-logo.png")} alt="Power Quiz Logo" />
        </div>
        <div className="col-4">
          <img className="asLogo" src={require("../assets/ageScotlandLogo.png")} alt="ageScotland Logo" />
        </div>
      </div>   
      <div className="under-logos">
        <div className="col-4"></div>
        <div className="col-4 action">
          <Link className="button" to="/about">Next</Link>
        </div>
        <div className="col-4"></div>
      </div>
    </div>  
    <div className="header-footer">
      <img className="footer" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
    </div>
  </div>
  );
} 

export default Title;
